import {useEffect} from 'react';
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import unarchive from "../../../../assets/vw/svg/unarchive.svg";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import archivar from "../../../../assets/vw/svg/archivar.svg";

function localDateTimeToUTC(date) {
    const fechaLocal = new Date(date);

    // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
    return fechaLocal.toISOString().slice(0, 19).replace("T", " ");
}
const CardContenido = ({infoCard, handleArchivar, editar, archivo, rowDesarchivar, setShowContent}) => {

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])
    

    return (
        <>
            <div className={"select-card-content mb-4 d-flex flex-wrap"} style={{marginTop: '20px'}} >
                <div className={"mr-5"}>
                    <div className="select-card-content-title font-azul-claro-secundario font-weight-bolder">Número:</div>
                    <div className="select-card-content-description">{infoCard.original.numCON ? infoCard.original.numCON : '-'}</div>
                </div>
                <div className={"mr-5"}>
                    <div className="select-card-content-title font-azul-claro-secundario font-weight-bolder">Marca:</div>
                    <div className="select-card-content-description">{infoCard.original.id_Marc ? infoCard.original.id_Marc : '-'}</div>
                </div>
                <div className={"pl-sm-0"}>
                    <div className="select-card-content-title font-azul-claro-secundario font-weight-bolder">Fecha de registro:</div>
                    <div className={"select-card-content-description"}>{infoCard.original.regFecha_Con ? localDateTimeToUTC(infoCard.original.regFecha_Con) : '-'}</div>
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={""}>
                    {
                        archivo ? (
                            <img src={inactivo_icono} alt="activo"></img>
                        ) : (
                            <img className={"mr-3"} src={activo_icono} alt="activo"></img>
                        )
                    }
                </div>
                <div className={"d-flex align-items-end"}>
                    {
                        archivo ? (
                            <button
                                className="button_icon-vw btn-desarchivar"
                                type="button"
                                onClick={() => rowDesarchivar({ row: infoCard })}
                            >
                                <div className="aling-icon-desarchivar font-azul-claro-complementario">
                                    {" "}
                                    <img
                                        src={unarchive}
                                        alt="unarchive"
                                        className="px-1"
                                    ></img>{" "}
                                    Desarchivar
                                </div>
                            </button>
                        ): (
                            <>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => editar(infoCard)}
                                >
                                    <div className="d-flex font-azul-claro-secundario">
                                        <div className={"editar-icon-mobile mr-2"}></div>
                                        Editar
                                    </div>
                                </button>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar({row: infoCard})}
                                >
                                    <div className="d-flex font-amarillo-complementario">
                                        {" "}
                                        <img
                                            src={archivar}
                                            alt="archivar"
                                            className="px-2"
                                        ></img>{" "}
                                        Archivar
                                    </div>
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    );
}

export default CardContenido;